module.exports = __webpack_public_path__ + "img/Image35.6849ee09.jpg";